import ProductDescription from './ProductDescription'

const BSInfantFruitsAndVegsProduct = {
  ...ProductDescription,
  category: '12',
  subCategory: '001BS',
  IsBroadband: true,
  ProductType: 'Fruit',
  PackageType: '',
  Size: '4 ounces only',
  MultiPackageType: false,
  MultiPackageCount: null,
  Organic: false,
  NoAdditionalIngredients: false,
}

export default BSInfantFruitsAndVegsProduct
